module.exports = __webpack_public_path__ + "img/cash-back.c4a6ce03.png";